<template>
    <div>
      <!-- <div class="box" :class="{'has-background-white-ter': selectedRecords.includes(row.id)}" @click="selectRecord(row)"> -->
      <div class="box">
        <div class="">
          <div class="columns">
            <div class="column is-12">
              <div class="buttons is-pulled-right">
                <b-dropdown
                  :triggers="['click']"
                  class="no-select"
                  position="is-bottom-left"
                  aria-role="list"
                >
                  <template #trigger>
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </template>
                  <b-dropdown-item
                    v-if="train"
                    aria-role="listitem"
                    @click="deleteDocument(row.id)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Delete record
                  </b-dropdown-item>
                  <b-dropdown-item v-if="train" aria-role="listitem" disabled>
                    <i class="fa fa-magic" aria-hidden="true"></i> AutoLabel suggestion
                  </b-dropdown-item>
                  <b-dropdown-item v-if="train" aria-role="listitem" disabled>
                    <i class="fa fa-plus" aria-hidden="true"></i> Generate similar
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!train"
                    @click="addRecord"
                    aria-role="listitem"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i> Add to training dataset
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <b-tag
                style="bottom: 0.3em; margin-right: 0.2em"
                size="is-small"
                type="is-light"
                >Text
              </b-tag>
              
              <TextAnnotation 
              v-if="Array.isArray(row.suggestion) && row.suggestion.length > 0"
              :key="`record-ner-suggestion-${row.id}`"
              :text="row.text" 
              v-model="row.suggestion" 
              :labels="this.project.labels" 
              @input="changeOutput(row)"
              @label-added="addLabel"
              :readonly="false"/>
              <TextAnnotation 
              v-else
              :key="`record-ner-${row.id}`"
              :text="row.text" 
              v-model="row.tags" 
              :labels="this.project.labels" 
              @input="changeOutput(row)"
              @label-added="addLabel"
              :readonly="false"/>
  
              <div class="" style="margin-top: 1em; margin-bottom: 0.5em">
  
                <!-- prediction-->
                
                <b-taglist attached v-if="!train">
                  <b-tag
                    style="bottom: 0.25em; margin-right: 1em"
                    size="is-small"
                    type="is-light"
                  >
                    Prediction
                  </b-tag>
                  <div :key="r" v-for="r in highlight(row.prediction)">
                        <div v-html="r"></div>
                  </div>
                  <b-tag
                    style="margin-right: 2px"
                    size="is-smallx"
                    v-if="row.prediction !== null"
                    type="is-light"
                    v-for="(prediction, index) in Array.isArray(row.prediction)
                      ? row.prediction
                      : [row.prediction]"
                  >
                    {{ prediction }}
                    <span
                      v-if="
                        (Array.isArray(row.confidence)
                          ? row.confidence[index]
                          : row.confidence) > 0
                      "
                    >
                      ({{
                        (Array.isArray(row.confidence)
                          ? row.confidence[index]
                          : row.confidence
                        ).toFixed(2)
                      }})
                    </span>
                  </b-tag>
                </b-taglist>
                <b-taglist attached v-else-if="!isPredictedEmply(row)">
                  <b-tag
                    style="bottom: 0.25em; margin-right: 1em"
                    size="is-small"
                    type="is-light"
                  >
                    Prediction
                  </b-tag>

              
  
                  <div style="margin-right: 0.2em;">
                    
                  <b-tooltip
                    type="is-dark is-light"
                    position="is-bottom"
                    multilined
                  >
                  <b-tag
                      size="is-smallx"
                      v-if="isLabelEmply(row)"
                      type="is-light"
                      >❓</b-tag
                    >
                    <b-tag
                      size="is-smallx"
                      v-else-if="isPredictedCorrectly(row) && !isLabelEmply(row)"
                      type="is-success"
                      >👍</b-tag
                    >
                    <b-tag
                      size="is-smallx"
                      v-else-if="!isPredictedCorrectly(row) && !isLabelEmply(row)"
                      type="is-danger"
                      >👎</b-tag
                    >
                    <b-tag size="is-smallx" v-else></b-tag>
                    &nbsp;
                    <template v-slot:content v-if="isPredictedCorrectly(row)">
                      <b>Predicted correctlly</b>.<br />
                      Obtained the predicted label and confidence score using the
                      Cross Validation method Leave One Out.
                    </template>
                    <template v-slot:content v-else-if="row.prediction == false">
                      AI model are going to predict or you need to retrain the
                      model to predict this one document.
                    </template>
                    <template
                      v-slot:content
                      v-else-if="
                        !isPredictedCorrectly(row) && isLabelEmply(row)
                      "
                    >
                      Predicted by the AI model, but you need to label the
                      document to accurate the model prediction.
                    </template>
                    <template
                      v-slot:content
                      v-else-if="
                        !isPredictedCorrectly(row) && !isLabelEmply(row)
                      "
                    >
                      <b>Predicted wrongly</b>.<br />
                      You can analyze the wrong predictions and check if it needed
                      to add more data for a specific label.
                    </template>
                  </b-tooltip>
                </div>
                

                  <div :key="r" v-for="r in highlight(row.text, row.prediction)">
                    <div v-html="r"></div>
                    </div>

                

                </b-taglist>
                
                
                <b-taglist attached v-if="Array.isArray(row.suggestion) && row.suggestion.length > 0">
                <b-tag
                  style="bottom: 0.25em; margin-right: 1em"
                  size="is-smallx"
                  type="is-white"
                >
                <svg xmlns="http://www.w3.org/2000/svg" height="11" width="13" viewBox="0 0 576 512"><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
                AutoLabel Suggestion
                </b-tag>
                
                
              
              <div class="buttons" v-if="Array.isArray(row.suggestion) && row.suggestion.length > 0">
              <b-button
                  style="margin-right: 2px"
                  class="button"
                  size="is-small"
                  type="is-success is-light"
                  @click="applySuggestion(row)"
                >
                  <span class="icon">
                    <i class="fa fa-check"></i>
                  </span>
                  &nbsp;Accept
                </b-button>
                <b-button
                  class="button"
                  size="is-small"
                  type="is-warning is-light"
                  @click="cancelSuggestion(row)"
                >
                  <span class="icon">
                    <i class="fa fa-ban"></i>
                  </span>
                  &nbsp;Ignore
                </b-button>
                </div>
            </b-taglist>
                
                <b-button
                  v-if="!train"
                  @click="addRecord"
                  class="button is-pulled-right"
                  size="is-small"
                  type="is-white is-light"
                >
                  <span class="icon">
                    <i class="fa fa-plus"></i>
                  </span>
                  &nbsp;Add to training
                </b-button>
  
                <p style="bottom: 0; margin-bottom: -1em; color: gray">
                  <small
                    ><small>
                      <span v-if="row.id"> Record: {{ row.id }} </span>
                      <span v-if="row.createdAt">
                        Date:
                        {{
                          new Date(parseInt(row.createdAt) * 1000).toDateString()
                        }}
                      </span>
  
                      <span v-if="isJsonString(row.metadata)">
                        <span v-for="(v, k) in JSON.parse(row.metadata)" :key="v">
                          <span v-if="k == 'extra'">
                            <span v-for="(extra_v, extra_k) in v" :key="extra_k">
                              {{ extra_k }}: {{ extra_v }}
                            </span>
                          </span>
                          <span v-else>{{ k }}: {{ v }}</span>
                        </span>
                      </span>
                    </small></small
                  >
                  <small><small> </small></small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TrainModel from "@/components/TrainModel.vue";
  import TrainRuns from "@/components/TrainRuns.vue";

  import ModalLabels from "@/components/ModalLabels.vue";
  import Annotation from "@/components/AnnotationTemplateNER.vue";
  import Patterns from "@/components/Patterns.vue";
  import AnnotationExtraction from "@/components/AnnotationTemplate.vue";
  import Uploads from "@/dashboard/Project/Uploads.vue";
  import Labels from "@/dashboard/Project/Labels.vue";
  import TextAnnotation from 'ner-text-annotation';
  import fuzzysort from "fuzzysort";
  import { mapState } from "vuex";
  import { timeout } from "q";
  
  export default {
    props: {
      train: Boolean,
      row: Object,
      project: Object,
      projectModels: Object,
      projectDatasets: Object,
      currentOrg: Object,
      currentUser: Object,
    },
    name: "Train",
    data: function () {
      return {
        perPage: 10,
        currentPage: 1,
        pageInput: 1,
        annotationMode: false,
        isMounting: true,
        checkedRows: [],
        isModalLabelsOpen: false,
        isModalPatternsOpen: false,
        isModalUploadOpen: false,
        viewFilter: this.$route.query.f == "errors" ? "issues" : "all",
        viewOptions: ["all", "labeled", "unlabeled", "issues"],
        versions: false,
        checkboxCustom: [],
        selected: { text: false, label: "unlabeled" },
        newLabel: false,
        selectedVersion: "v1",
        animated: true,
        candidateLabels: [(1, 1), (2, 3)],
        isModalTrainCreateOpen: false,
        labelKeys: [],
        options: {},
        total: 0,
        predicted: "any",
        given: "any",
        search: null,
        sortBy: null,
        filterByDataset: "any",
        uploadList: [],
        labelsViewMin: 20,
        selectedRecords: [],
        project_labels: this.project.labels.map(({ label }) => label),
        record_in_training: null,
        text: "Vue.js is a progressive JavaScript framework, which is used to build UIs (User Interfaces) and SPAs (Single-page Applications). This framework is famous for its fast-paced learning curve. It is such an easy to learn and approachable library that with the knowledge of HTML, CSS, and JavaScript, we can start building web applications in Vue.js. The fast learning curve is kind of a signature of this framework. It is a versatile framework for our need as a library or a full-fledged framework for building huge web apps.\nEvan You have created this framework. The idea of Evan You behind this framework is to build the best framework by combining the best features from already existing Angular and react Frameworks. Before building Vue.js, Evan You was working at Google. Inc and worked on Angular based projects. So, he came up with the idea of building his own framework. He picked the best parts of Angular, like template syntax, easy to use, and picked the best parts of React as well, like two-way data binding, the concept of props, component-based approach, and combined them to make a new framework Vue.js better than both of them.",
        textAnnotations: [],
      };
    },
    components: {
      "modal-train": TrainModel,
      "train-runs": TrainRuns,
      ModalLabels,
      Annotation,
      Patterns,
      AnnotationExtraction,
      Uploads,
      Labels,
      TextAnnotation,
    },
  
    computed: {
      metrics() {
        return this.$store.getters.progressMetrics(this.project.datasetId);
      },
      isLoading() {
        return this.$store.getters.isLoading;
      },
      
      documents() {
        return this.sortDocuments(
          this.fuzzySearchFilter(
            this.$store.getters
              .rowsByDataset(this.project.datasetId)
              .filter(
                (item) =>
                  this.givenFilter(item) &&
                  this.predictedFilter(item) &&
                  this.searchFilter(item) &&
                  this.datasetFilter(item)
              )
          )
        );
      },
    },
    filters: {
      dateFormat: function (value) {
        // from timestamp to date
        // parse to int
        value = parseInt(value);
        return new Date(value).toLocaleString("en-US", {
          timeZone: "UTC",
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      },
    },
    methods: {
        addLabel(newLabel){
            this.project.labels = this.project.labels.concat({
                label_code: this.project.labels.length + 1,
                label: newLabel,
            })

            const projectToUpdate = {
                projectId: this.project.id,
                update: {
                    labels: this.project.labels
                }
            }

            this.$store.dispatch('updateProject', projectToUpdate)
        },
        highlight(text, result) {
          if (!result) return;
          
          if(this.project.type != 'extraction') {
            return result;
          }
          
          let highlight = []
          let highlight_text = ''
          result.forEach(async (r) => {
            // highlight_text = highlight_text.replace(new RegExp(r.text, "gi"), match => {
            //   return `<span style="margin-bottom: 5px" data-entity="-1">${match} <span class='entities-type'><b>${r.label}</b></span></span>`;
            // });
            highlight_text = `<span style="margin-bottom: 5px" data-entity="-1">${r.text} <span class='entities-type'><b>${r.label}</b></span></span>`
            
            highlight.push(highlight_text)
          });
          
          return highlight
        },
      addRecord() {
        this.$store.dispatch("addRecord", {
          text: this.row.text,
          prediction: this.row.prediction,
          confidence: this.row.confidence,
          labels: null,
          projectId: this.project.id,
        });
      },
      selectRecord(row) {
        if (!this.selectedRecords.includes(row.id)) {
          this.selectedRecords.push(row.id);
        } else {
          const idx = this.selectedRecords.indexOf(row.id);
          this.selectedRecords.splice(idx, 1);
        }
      },
      isJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      },
      nextPage() {
        let totalRows = this.rows.length;
        this.currentPage = this.currentPage + 1;
        console.log(this.currentPage, totalRows);
  
        if (this.currentPage > totalRows || this.currentPage > 5) {
          console.log("realoading");
          this.$store
            .dispatch("getRowsByDatasetForAnnotation", this.project.datasetId)
            .then(() => {
              this.currentPage = 1;
            });
        }
      },
      enableAnnotationMode() {
        //this.$store.dispatch('getRowsByDatasetForAnnotation', this.project.datasetId)
      },
      triggerTraining() {
        this.$store.dispatch("triggerTraining", { projectId: this.project.id });
      },
      deleteDocument(rowId) {
        this.$store.dispatch("deleteRow", rowId);
        this.$store.getters.removeRow(rowId);
        // this.triggerTraining();
      },
      checkLabelDist() {
        let labelsOk = 0;
        for (label of this.project.labels) {
          if (
            this.projectDocuments.filter((item) => item.label == label.label)
              .length >= 10
          ) {
            labelsOk += 1;
          }
        }
  
        if (labelsOk == this.project.labels.length) {
          console.log("ok");
        }
      },
      isLabelEmply(row) {
        if (!Array.isArray(row.tags)) return true;
        if (row.tags.length < 1) return true;
        else return false;
      },
      isPredictedEmply(row) {
        if (!Object.hasOwn(row, "prediction")) return true
        else if (!Array.isArray(row.prediction)) return true;
        else if (row.prediction.length < 1) return true;
        else return false;
      },
      isSuggestionEmply(row) {
        if (!Array.isArray(row.suggestion)) return true;
        if (row.suggestion.length < 1) return true;
        else return false;
      },
      isPredictedCorrectly(row) {
        if (this.isPredictedEmply(row)) return -1
        else if (!Array.isArray(row.prediction)) return -1;
        else if (!Array.isArray(row.tags)) return -1;
        else if (row.prediction.length < 1) return -1;
        else if (row.tags.length != row.prediction.length) return 0;
        else if ( 
            row.tags.filter( tag => row.prediction.filter( p => p.text == tag.text).length > 0).length > 0
        )
          return 1;
        else
          return 0
        // else if (row.labels.every( label => row.prediction.includes(label) )) return true
        // else return false
      },
      cancelSuggestion(row){
        const rowToUpdate = {
            datasetId: this.project.datasetId,
            id: row.id,
            suggestion: []
        };

        this.$store.dispatch("updateRow", rowToUpdate).then(() => {
            let substring = this.row.text.slice(0, 30);
            this.$buefy.snackbar.open({
                duration: 1400,
                queue: true,
                message: `<b>Ignored LLM suggestion</b><br>Text: <em>${substring}...</em>.`,
                type: "is-white",
                position: "is-bottom-left",
                pauseOnHover: true,
                actionText: "Cancel",
                queue: true,
            });
        })
      },
      applySuggestion(row){
        const rowToUpdate = {
            datasetId: this.project.datasetId,
            id: row.id,
            tags: row.suggestion,
            suggestion: []
        };

        this.$store.dispatch("updateRow", rowToUpdate).then(() => {
            let substring = this.row.text.slice(0, 30);
            this.$buefy.snackbar.open({
                duration: 1400,
                queue: true,
                message: `<b>Applied AutoLabel suggestion</b><br>Text: <em>${substring}...</em>.`,
                type: "is-white",
                position: "is-bottom-left",
                pauseOnHover: true,
                actionText: "Cancel",
                queue: true,
            });
            // this.$emit("reload", true)
            this.$forceUpdate();
        })

      },
      changeOutput(row, notification = true) {

        // update the record in the data source
        const project_labels = this.project.labels.map(({ label }) => label);

        // row.labels = row.labels.filter((label) => project_labels.includes(label.annotation));
        const rowToUpdate = {
          datasetId: this.project.datasetId,
          id: row.id,
          tags: row.tags,
          suggestion: row.suggestion
        };
        const annotatedAs = row.tags.map(item => item.label).join(', ')
  
        this.$store.dispatch("updateRow", rowToUpdate).then(() => {
          if (notification) {
            let substring = row.text.slice(0, 30);
  
            this.$buefy.snackbar.open({
              duration: 1400,
              queue: true,
              message: `<b>Annotated ${annotatedAs}</b><br>Text: <em>${substring}...</em>.`,
              type: "is-white",
              position: "is-bottom-left",
              pauseOnHover: true,
              actionText: "Cancel",
              onAction: () => {
                this.$buefy.toast.open({
                  message: "Annotations canceled",
                  queue: true,
                });
                let _row = row;
                _row.labels = [];
                _row.tags = [];
                this.changeOutput(_row, false);
              },
            });
          }
        });
        this.triggerTraining();
  
        // must have datasetId, text (or label)
      },
      changeFilter() {
        //   this.documents = this.getDocuments()
      },
      getLabels() {
        return this.project.labels ? this.project.labels : [];
      },
      predictedFilter(item) {
        if (this.predicted == "not") {
          return (
            this.isPredictedEmply(item.prediction) ||
            !Array.isArray(item.prediction) ||
            item.prediction == [] ||
            item.prediction == null ||
            item.prediction == NaN ||
            item.prediction == false
          );
        } else if (this.predicted == "agrees") {
          return this.isPredictedCorrectly(item) == true;
        } else if (this.predicted == "disagrees") {
          return this.isPredictedCorrectly(item) == false;
        } else if (this.predicted != "any") {
          return item.prediction.includes(this.predicted);
        } else if (this.predicted == "any") {
          return true;
        } else {
          return false;
        }
      },
      validLabels(record_labels) {
        if (!this.project.labels) return false;
        if (!record_labels) return false;
        let project_labels = this.project.labels.map(({ label }) => label);
        return project_labels.some((label) => record_labels.includes(label));
      },
      validRecordLabels(record_labels) {
        if (!record_labels) return false;
        return Array.isArray(record_labels) && record_labels.length > 0;
      },
      validLabelsIncludes(labels, given) {
        if (!this.validRecordLabels(labels)) return false;
        else {
          return labels.includes(given);
        }
      },
      givenFilter(item) {
        let is_labeled = this.validRecordLabels(item.labels || []);
        let is_valid_labels = this.validLabels(item.labels || []);
        let is_label_contains = this.validLabelsIncludes(item.labels, this.given);
  
        if (this.given === "unlabeled") {
          return (
            !is_valid_labels ||
            !is_labeled ||
            item.labels === undefined ||
            item.labels === false ||
            item.labels == null ||
            item.labels === "False" ||
            item.labels === undefined
          );
        } else if (this.given != "any") {
          return is_label_contains;
        } else if (this.given === "any") {
          return true;
        } else {
          return false;
        }
      },
      searchFilter(item) {
        return true;
        if (this.search != null) {
          return item.text.toLowerCase().includes(this.search.toLowerCase());
        } else {
          return true;
        }
      },
      fuzzySearchFilter(docs) {
        const options = {
          key: "text",
          limit: 200, // don't return more results than you need!
          threshold: -10000, // don't return bad results
        };
        const recordId = "021d268f7761f169d8df8b78243d69ea";
  
        if (this.search != null && this.search != "") {
          const isSearchId = this.search.length === recordId.length;
  
          if (isSearchId) {
            return docs.filter((i) => this.search == i.id);
          }
  
          return fuzzysort.go(this.search, docs, options).flatMap((r) => r.obj);
        } else {
          return docs;
        }
      },
      datasetFilter(item) {
        if (this.filterByDataset !== "any") {
          return item.uploadId === this.filterByDataset;
        } else {
          return true;
        }
      },
      sortDocuments(doc) {
        if (this.sortBy == "high_score") {
          return doc.sort((a, b) => b.confidence - a.confidence);
        } else if (this.sortBy == "low_score") {
          return doc.sort((a, b) => a.confidence - b.confidence);
        } else {
          return doc;
        }
      },
    },
    mounted() {
      this.project_labels = this.project.labels.map(({ label }) => label);
      const labelKeys = [
        "Digit1",
        "Digit2",
        "Digit3",
        "Digit4",
        "Digit5",
        "Digit6",
        "Digit7",
        "Digit8",
        "Digit9",
        "Digit0",
      ];
      window.addEventListener("keypress", (e) => {
        if (["KeyN", "KeyC"].includes(e.code) && this.annotationMode) {
          this.nextPage();
        } else if (["KeyA"].includes(e.code) && this.annotationMode) {
          let prediction = this.documents[this.currentPage - 1].prediction;
          if (prediction && this.documents.length == 1) {
            this.documents[this.currentPage - 1].label = prediction;
            this.changeOutput(this.documents[this.currentPage - 1], true);
          }
        } else if (labelKeys.includes(e.code) && this.annotationMode) {
          let labels = this.getLabels();
          let idx = parseInt(e.code.slice(-1)) - 1;
  
          let c = labels[idx];
          this.documents[this.currentPage - 1].label = c.label;
          this.changeOutput(this.documents[this.currentPage - 1], true);
        }
      });
    },
    created() {},
  };
  </script>
  <style lang="scss" scoped>
  .vertical {
    height: 500px;
    /*Altura da linha*/
    border-left: 2px solid;
    /* Adiciona borda esquerda na div como ser fosse uma linha.*/
  }
  
  .no-active:focus {
    outline: none;
  }
  
  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .labelCode {
    position: absolute;
    /* Set the span's position to absolute */
    bottom: 0;
    /* Align the span to the bottom */
    left: 50%;
    /* Align the span horizontally */
    transform: translateX(-50%);
    /* Center the span horizontally */
    font-size: 9px;
    /* Set the font size of the span */
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to
  
  /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }
  </style>
  